export const baseUrl = {
  //# api模块地址
  apiURL:"/platform-api",
  
  //# base模块地址
  baseURL:"/platform-base",
  
  //# cms模块地址
  cmsURL:"/platform-cms",
  
  //# comment模块地址
  commentURL:"/platform-comment",
  
  //# count模块地址
  countURL:"/platform-count",
  
  //# goods模块地址
  goodsURL:"/platform-goods",
  
  //# integral模块地址
  integralURL:"/platform-integral",
  
  //# log模块地址
  logURL:"/platform-log",
  
  //# login模块地址
  loginURL:"/platform-login",
  
  //# mall模块地址
  mallURL:"/platform-mall",
  
  //# marketing模块地址
  marketingURL:"/platform-marketing",
  
  //# merchant模块地址
  merchantURL:"/platform-merchant",
  
  //# order模块地址
  orderURL:"/platform-order",
  
  //# payment模块地址
  paymentURL:"/platform-payment",
  
  //# role模块地址
  roleURL:"/platform-role",
  
  //# search模块地址
  searchURL:"/platform-search",
  
  //# statistics模块地址
  statisticsURL:"/platform-statistics",
  
  //# stock模块地址
  stockURL:"/platform-stock",
  
  //# user模块地址
  userURL:"/platform-user",

  //# cart模块地址
  cartURL:"/platform-cart",
};
export function oneByOneSet(obj,data){
  for(let i in data)
  obj[`${"$"+i}`] = data[i]
}



// WEBPACK FOOTER //
// ./src/common/js/baseUrl.js